import React, { useContext, useEffect, useState } from "react";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import {
  GridColDef,
  GridValidRowModel,
  GridAlignment,
} from "@mui/x-data-grid-pro";
import { TableHeaderProps } from "../../../../../../utils/types";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import Assign from "../../../../../../images/Assign.svg";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import { Button } from "../../../../../../stories/Button/Button";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import {
  AtsMrfMstEdge,
  AtsMrfMstOrderField,
  GetMrfsResult,
  GetMrfsVars,
  MrfQueryType,
} from "../../material/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../../context/context";
import { GetMrfs } from "../../material/queries/queries";
import { useLazyQuery } from "@apollo/client";

import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import {
  getModifiedScrollHeight,
  toInputStandardDate,
  toIsoDate,
} from "../../../../../../utils/UtilFunctions";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { formDates } from "../../material/ApprovedList";

const Data = [
  {
    mrf_no: 1,
    mrf_date: "10-10-2023",
    subsidiary: "Demo",
    total_items: 0,
    total_quantity: 0,
    approx_netvalue: 0,
    acceptance_made_by: "harin",
    remark: "same remark",
  },
];

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const MrfDetails = ({ setModalFlag }: Props) => {
  const { Purchase } = useAssetTableJson();

  const [rfqs, setRfqs] = useState<AtsMrfMstEdge[]>([]);

  const { customer_id } = useUrlParams();

  const { state } = useContext(AppContext);

 

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const [GetMrf, { loading, data: mrfData, fetchMore }] = useLazyQuery<
    GetMrfsResult,
    GetMrfsVars
  >(GetMrfs);

  const dynamicHeaders: TableHeaderProps[] =
    Purchase.PurchaseOrder.MrfDetails.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: (params) => {
        if (params.row.id === 1 && header.field === "actions") {
          return (
            <>
              <button className="mrf-details__tableblock--choose">
                Choose MRF <img src={Assign} alt="" />{" "}
              </button>
            </>
          );
        }
        return params.value;
      },
    }));

  const columns: GridColDef[] = [...dynamicHeaders];
  const rows: GridValidRowModel[] = [
    ...(rfqs || []).map((data, index) => {
      return {
        id: index + 1, // Ensure the ID is unique
        mrf_no: data.node.mrfNo, // Leave empty or provide placeholder values
        mrf_date: toInputStandardDate(data.node.mrfDate),
        subsidiary: data.node.subsidiary.name,
        total_item_accepted: data.node.itemQty,
        total_quantity_accepted: data.node.totalQty,
        approx_net_value: 0,
        acceptance_made_by: EMPTY_STRING,
        remarks: data.node.remarks,
        actions: "",
      };
    }),
  ];

  useEffect(() => {
    if (customer_id && state.ActiveFinYr) {
      GetMrf({
        variables: {
         
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: ROWS_PER_PAGE,
          name: EMPTY_STRING,
          end_date: toIsoDate(dates.endDate),
          start_date: toIsoDate(dates.startDate),
          queryType: MrfQueryType.APPROVED_MRFS,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfMstOrderField.MRF_DATE,
          },
        },
      });
    }
  }, [customer_id, state.ActiveFinYr, GetMrf, dates.endDate, dates.startDate]);
  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetMrfs.edges;
              const pageInfo = fetchMoreResult.GetMrfs.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetMrfs.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetMrfs: {
                  edges: [...rfqs, ...newEdges],
                  pageInfo,
                  totalCount: mrfData ? mrfData.GetMrfs.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    if (mrfData && !loading) {
      const newData = mrfData.GetMrfs.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = rfqs.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setRfqs(updatedNewData);
      } else {
        setRfqs(newData);
      }
      setEndCursor(mrfData.GetMrfs.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [mrfData, loading]);

  return (
    <>
      <div className="mrf-details">
        <div className="mrf-details__title">
          <Title>Mrf Details</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="mrf-details__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
    </>
  );
};

export default MrfDetails;
